// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__k0a74","gfeWrapper":"CalendarEvent_gfeWrapper__2Bi0t"};